import { themeObject } from 'lib';

export interface CancelModalProps {
    cancelModal: boolean;
    handleCancelModal?: () => void;
    cancelButtonText: string;
    cancelHeadingText: string;
    cancelSubHeadingText?: string;
    cancelModalText?: string;
    handleCancel?: () => void;
    children?: React.ReactNode;
}

export const styles = {
    dialogStyles: {
        '& .MuiPaper-root': {
            width: '462px',
            '& .MuiDialogContent-root': {
                p: '0px 35px 35px 35px',
                overflow: 'hidden',
            },
        },
    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 1,
        mt: 2.5,
    },
    subHeadingTextStyles: {
        ...themeObject.typography.body.default,
        ...themeObject.typography.body.body1,
        ...themeObject.typography.body.regular,
        lineHeight: '21.17px',
        color: themeObject.palette.grayScale[800],
    },
};
